import React, { useCallback, useContext, useEffect } from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import {
  FormControl,
  FormHelperText,
  Radio,
  RadioGroup,
} from "@mui/material";
import Label from "./LabelF";
import { getAtributo } from "../../../context/FuncionesContext";
import axios from "axios";
import { farmageo_api } from "../../../../../config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import FuncionesContext from "../../../context/FuncionesContext";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";

const InputRadio = ({
  setValor,
  valor,
  cab,
  error,
  setError,
  data,
  valorFormulario,
  modoAlta,
  id_elemento,
}) => {
  const {
    id_a,
    nombre,
    opcionales_null,
    permite_null,
    margin_bottom_abm,
    width,
    select_es_maestro,
    select_depende_de,
    select_info_adicional,
    select_info_adicional_campo,
    refrescarConfiguracion,
  } = cab;

  const { renderEnModal, refrescarConfiguracion: refrescarConfiguracionF } =
    useContext(FuncionesContext);

  const disabled = getAtributo("disabled", data, cab) === "s";
  const def = getAtributo("default", data, cab);

  const tieneError = Boolean(error?.[id_a]);

  const componerOpciones = () => {
    const value_null =
      data[cab.id_a + "_select_value_null"] ?? cab.select_value_null;
    const label_null =
      data[cab.id_a + "_select_label_null"] ?? cab.select_label_null;
    const opcion_null = {
      value: value_null ? value_null : null,
      label: label_null ? label_null : "Ninguno",
      disabled,
    };

    if (Array.isArray(cab.opciones)) return cab.opciones;
    if (data[cab.id_a + "_opciones"]) {
      const opciones_de_query_general = JSON.parse(
        data[cab.id_a + "_opciones"]
      );

      if (Array.isArray(opciones_de_query_general)) {
        if (value_null || label_null) {
          opciones_de_query_general.push(opcion_null);
        }
        return opciones_de_query_general;
      }
    }
    if (value_null || label_null) {
      return [opcion_null];
    }
    return [];
  };

  const [opciones, setOp] = React.useState(componerOpciones());
  const [opElegida, setOpElegida] = React.useState(
    opciones.find((op) => op.value === valor)
  );
  const [loadingOptions, setLoadingOptions] = React.useState(false);

  const getOpciones = useCallback(
    async (ev) => {
      const body = {
        id_a,
        dependencias: {},
      };

      const select_depende_de_array = select_depende_de.split("|");
      for (const meastro_id_a of select_depende_de_array) {
        body.dependencias[meastro_id_a] = valorFormulario[meastro_id_a];
        if (ev?.detail?.[meastro_id_a]) {
          body.dependencias[meastro_id_a] = ev.detail[meastro_id_a];
        }
      }

      setLoadingOptions(true);
      await axios
        .post(farmageo_api + "/select/opcionesv2", body)
        .then((response) => {
          const nuevasOpciones = response.data ?? [];
          const opValida = nuevasOpciones.find((op) => op.value === valor);
          setOp(nuevasOpciones);
          setOpElegida(opValida);
          setValor(opValida ?? { value: "null" }, cab.id_a);
        })
        .finally(() => {
          setLoadingOptions(false);
        });
    },
    [cab.id_a, id_a, select_depende_de, setValor, valor, valorFormulario]
  );

  const style_input_abm = {
    width,
    marginBottom: margin_bottom_abm,
  };

  useEffect(() => {
    if (valor || def) {
      if (valor && select_es_maestro === "s") {
        const selectEvent = new CustomEvent(id_a + "_cambio", {
          detail: { [cab.id_a]: valor },
        });
        document.dispatchEvent(selectEvent);
      }
      if (modoAlta) {
        setValor(def);
        if (select_es_maestro === "s") {
          const selectEvent = new CustomEvent(id_a + "_cambio", {
            detail: { [cab.id_a]: def },
          });
          document.dispatchEvent(selectEvent);
        }
      }
    }
    if (select_depende_de) {
      const dependencias = select_depende_de.split("|");

      if (dependencias.some((dep) => !!valorFormulario[dep])) {
        getOpciones();
      }
    }
  }, [
    cab.default,
    def,
    getOpciones,
    id_a,
    modoAlta,
    select_depende_de,
    select_es_maestro,
    setValor,
    valor,
    valorFormulario,
  ]);

  useEffect(() => {
    if (select_depende_de && select_depende_de !== "") {
      select_depende_de.split("|").forEach((meastro_id_a) => {
        if (meastro_id_a && meastro_id_a !== "") {
          document.addEventListener(meastro_id_a + "_cambio", getOpciones);
        }
      });
    }
    return () => {
      if (select_depende_de && select_depende_de !== "") {
        select_depende_de.split("|").forEach((meastro_id_a) => {
          if (meastro_id_a && meastro_id_a !== "") {
            document.removeEventListener(meastro_id_a + "_cambio", getOpciones);
          }
        });
      }
    };
  }, [getOpciones, select_depende_de]);

  const handleChange = (e) => {
    const newOpElegida = opciones.find(
      (op) => String(op.value) === String(e.target.value)
    );

    setValor(newOpElegida, cab.id_a);
    setOpElegida(newOpElegida);
    setError((prev) => {
      const ne = { ...prev };
      ne[id_a] = false;
      return ne;
    });

    if (select_es_maestro === "s") {
      const selectEvent = new CustomEvent(id_a + "_cambio", {
        detail: { [cab.id_a]: e.target.value, newOpElegida },
      });
      document.dispatchEvent(selectEvent);
    }
    if (refrescarConfiguracion && refrescarConfiguracion.trim() !== "") {
      refrescarConfiguracionF({ cab });
    }
  };

  if (cab.select_opcion_unica === "s") {
    return (
      <Default
        data={data}
        cab={cab}
        valor={opciones[0]?.label}
        id_elemento={id_elemento}
      />
    );
  }

  return (
    <div style={style_input_abm}>
      <FormControl fullWidth error={tieneError}>
        <Label
          label={nombre}
          opcionales_null={opcionales_null}
          permite_null={permite_null}
        />

        <RadioGroup
          id={id_elemento}
          value={valor == null ? "" : String(valor)}
          onChange={handleChange}
          row
          sx={{
            width: "100%",
            boxSizing: "border-box",
            border: "1px solid",
            borderColor: tieneError ? "error.main" : "transparent",
            borderRadius: "4px",
            padding: "4px 8px",
          }}
        >
          {loadingOptions ? (
            <FormControlLabel
              value=""
              control={<Radio />}
              label="Cargando opciones ..."
              disabled
            />
          ) : (
            opciones.map((opcion) => (
              <FormControlLabel
                key={opcion.value + opcion.label}
                value={String(opcion.value ?? "")}
                control={<Radio />}
                label={opcion.default ? <em>{opcion.label}</em> : opcion.label}
                disabled={disabled || opcion.disabled}
              />
            ))
          )}
        </RadioGroup>

        {tieneError && (
          <FormHelperText>Debe seleccionar una opción.</FormHelperText>
        )}

        {select_info_adicional && opElegida && select_info_adicional_campo ? (
          <div
            style={{
              cursor: "pointer",
              fontSize: "1rem",
              marginLeft: "1rem",
              position: "absolute",
              top: "50%",
              left: "100%",
            }}
            onClick={() =>
              renderEnModal(opElegida[select_info_adicional_campo], {
                modal: "modal-viewportWidth80",
              })
            }
          >
            <FontAwesomeIcon icon={faInfoCircle} />
          </div>
        ) : (
          <></>
        )}
      </FormControl>
    </div>
  );
};

export default InputRadio;

function Default({ data, cab, hijos, id_elemento, valor }) {
  return (
    <>
      <div id={id_elemento} className="tarjeta_grid_item_label_item">
        <div
          className={data[cab.id_a + "_className"]}
          style={{ width: cab.width }}
        >
          <div style={{ textAlign: cab.align }}>{valor}</div>
        </div>
      </div>
      {hijos?.map((hijo) => hijo)}
    </>
  );
}